<div class="sms-dashboard">
  <h3>Dashboard de SMS</h3>

  <div class="filters">
    <form [formGroup]="dateFilterForm" class="form-b4a">
      <span class="p-float-label">
        <p-calendar
          formControlName="startDate"
          inputId="smsStartDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [maxDate]="dateFilterForm.controls.endDate.value || today"
          appendTo="body"
        />
        <label for="smsStartDate">Data Inicial</label>
      </span>

      <span class="p-float-label">
        <p-calendar
          formControlName="endDate"
          inputId="smsEndDate"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [minDate]="dateFilterForm.controls.startDate.value"
          [maxDate]="today"
          appendTo="body"
        />
        <label for="smsEndDate">Data Final</label>
      </span>

      <p-button
        icon="pi pi-search"
        [disabled]="dateFilterForm.invalid"
        (onClick)="loadAnalytics()"
        pTooltip="Buscar"
        tooltipPosition="bottom"
      />
    </form>
  </div>

  <ng-container *ngIf="analytics; else smsEmpty">
    <div class="totals">
      <div class="dashboard-card" *ngFor="let card of summaryCards">
        <span class="header" [ngClass]="card.headerClass">
          {{ card.title }}
        </span>
        <span class="value" [class.value--rate]="card.isRate">
          {{ card.value }}
        </span>
        <span class="sms-card-detail">{{ card.description }}</span>
      </div>
    </div>

    <div class="dashboard">
      <p-chart
        type="bar"
        [data]="chartData"
        [options]="chartOptions"
        id="sms-chart"
        [responsive]="false"
        width="100%"
        height="400px"
        *ngIf="chartData"
      />
    </div>

    <div class="sms-detail-grid__toolbar">
      <p-button
        label="Ver erros"
        icon="pi pi-exclamation-triangle"
        [disabled]="dateFilterForm.invalid"
        (onClick)="openErrorsModal()"
      />
    </div>

    <div class="sms-detail-grid">
      <div class="sms-detail-card">
        <div class="sms-detail-card__header">
          <i class="pi pi-ban"></i>
          <h4>Códigos descartados</h4>
        </div>
        <div class="sms-detail-row" *ngFor="let row of droppedRows">
          <span class="sms-detail-label">{{ row.label }}</span>
          <span class="sms-detail-value">{{ row.count }}</span>
          <span class="sms-detail-rate">{{ row.rate }}</span>
          <span class="sms-detail-details" *ngIf="row.detailsLabel">
            {{ row.detailsLabel }}
          </span>
        </div>
      </div>

      <div class="sms-detail-card">
        <div class="sms-detail-card__header">
          <i class="pi pi-times-circle"></i>
          <h4>Códigos não entregues</h4>
        </div>
        <div class="sms-detail-row" *ngFor="let row of undeliveredRows">
          <span class="sms-detail-label">{{ row.label }}</span>
          <span class="sms-detail-value">{{ row.count }}</span>
          <span class="sms-detail-rate">{{ row.rate }}</span>
          <span class="sms-detail-details" *ngIf="row.detailsLabel">
            {{ row.detailsLabel }}
          </span>
        </div>
      </div>

      <div class="sms-detail-card">
        <div class="sms-detail-card__header">
          <i class="pi pi-clock"></i>
          <h4>Códigos não verificados</h4>
        </div>
        <div class="sms-detail-row" *ngFor="let row of unverifiedRows">
          <span class="sms-detail-label">{{ row.label }}</span>
          <span class="sms-detail-value">{{ row.count }}</span>
          <span class="sms-detail-rate">{{ row.rate }}</span>
          <span class="sms-detail-details" *ngIf="row.detailsLabel">
            {{ row.detailsLabel }}
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #smsEmpty>
  <div class="sms-empty">Nenhum dado disponível.</div>
</ng-template>

<p-dialog
  [(visible)]="errorsModalVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  header="Erros de OTP SMS"
  [style]="{ width: '92vw' }"
  [contentStyle]="{ overflow: 'auto' }"
>
  <app-table
    *ngIf="errorsModalVisible"
    [cols]="errorCols"
    [service]="smsOtpErrorService"
    [findPage]="findErrorsPage"
    [lazy]="true"
    [addButton]="false"
    [dropdownFilters]="channelDropdownFilters"
    modelName="erros"
    emptyMessage="Nenhum erro no período"
    sortField="updatedAt"
    [sortOrder]="-1"
    [defaultRows]="50"
  />
</p-dialog>
